import React, { Component } from "react";
import PropTypes from "prop-types";
import { is } from "immutable";
import Request from "superagent";
import { OrderedMap } from "immutable";

import { API_BASE } from "./api";
import Player from "./Player";
import Picks, { PICK_STATES } from "./Picks";
import {
  ACUMIN,
  ACUMIN_CONDENSED,
  COLOR_GRAY_STYLE,
  COLOR_GREEN,
  COLOR_GREEN_STYLE,
  GRAY_LINK_STYLE,
} from "./styles";

export const MAX_NAME_LEN = 16;

const NAME_WIDTH = 160;
const INIT_WIDTH = 70;

const TR_STYLE = Object.assign(
  { fontSize: 24, cursor: "pointer", fontWeight: 200 },
  ACUMIN_CONDENSED,
);

const INPUT_GRAY = "#dadada";

class PlayerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: props.players.size === 0,
      longName: "",
      shortName: "",
    };

    this.onPlus = this.onPlus.bind(this);
    this.onClickAddPlayer = this.onClickAddPlayer.bind(this);
    this.onChangeLongName = this.onChangeLongName.bind(this);
    this.onChangeShortName = this.onChangeShortName.bind(this);
  }

  componentDidMount() {
    if (this.state.editing) {
      this.longNameInput.focus();
    }
  }

  onPlus(e) {
    e.preventDefault();
    this.props.deselectPlayer();
    this.setState(
      {
        editing: true,
        longName: "",
        shortName: "",
      },
      () => {
        this.longNameInput.focus();
      },
    );
  }

  onClickAddPlayer(e) {
    if (this.inFlight) {
      return;
    }
    const { lobbyCode, picks } = this.props;
    const shortName = (this.state.shortName || "").trim();
    const longName = (this.state.longName || "").trim();
    if (shortName.length < 2) {
      alert("Initials must be at least 2 characters");
      return;
    }
    if (longName.length < 2) {
      alert("Please add a full name (at least 2 characters long)");
      return;
    }
    if (picks.players.has(shortName)) {
      alert(`Someone already has the initials ${shortName}. You must enter something else.`);
      return;
    }
    const player = new Player({ shortName, longName });

    this.inFlight = true;
    Request.post(`${API_BASE}/lobby/${lobbyCode}/players`)
      .send({ shortName, longName })
      .end((err, res) => {
        this.inFlight = false;
        if (err) {
          alert("Error adding player");
          return;
        }

        // TODO mid-air dup handling

        this.setState({
          shortName: "",
          longName: "",
          editing: false,
        });
        this.props.addPlayer(player);
      });
  }

  onChangeShortName(e) {
    this.setState({ shortName: e.target.value.substr(0, 3).toUpperCase() });
  }

  onChangeLongName(e) {
    this.setState({ longName: e.target.value.substr(0, MAX_NAME_LEN) });
  }

  render() {
    const { picks, players, onClickPlayer, selected } = this.props;
    const { editing, longName, shortName } = this.state;
    const locked = picks.state !== PICK_STATES.INITIAL;
    const plusRow =
      editing || locked || picks.total === 100 ? null : (
        <tr style={TR_STYLE}>
          <td />
          <td style={{ cursor: "pointer" }} onClick={this.onPlus} title="Add a player">
            <a href="/add_a_player" style={GRAY_LINK_STYLE} className="ulh">
              + new player
            </a>
          </td>
        </tr>
      );

    return (
      <div style={{ color: "#555" }}>
        <table style={{ borderSpacing: 5, lineHeight: 1.2, width: 330 }}>
          <tbody>
            <tr style={TR_STYLE}>
              <td />
              <td style={Object.assign({ fontWeight: 200, fontSize: 40 }, ACUMIN)}>players</td>
            </tr>
            {players &&
              players.valueSeq().map((p, i) => {
                const style = is(p, selected) ? COLOR_GREEN_STYLE : null;
                return (
                  <tr
                    key={p.shortName}
                    style={TR_STYLE}
                    onClick={() => {
                      onClickPlayer(p);
                    }}
                  >
                    <td>{i + 1}.</td>
                    <td style={Object.assign({ width: NAME_WIDTH }, style)}>{p.longName}</td>
                    <td style={Object.assign({ width: INIT_WIDTH }, COLOR_GRAY_STYLE, style)}>
                      {p.shortName}
                    </td>
                    <td
                      style={Object.assign(
                        { width: INIT_WIDTH, textAlign: "center" },
                        COLOR_GRAY_STYLE,
                        style,
                      )}
                    >
                      {picks.playerCount(p)}
                    </td>
                  </tr>
                );
              })}
            {editing && (
              <tr style={TR_STYLE}>
                <td>{players.size + 1}.</td>
                <td style={{ width: NAME_WIDTH }}>
                  <input
                    type="text"
                    value={longName}
                    onChange={this.onChangeLongName}
                    placeholder="Name"
                    style={Object.assign(
                      {
                        boxSizing: "border-box",
                        width: NAME_WIDTH,
                        backgroundColor: INPUT_GRAY,
                        border: "none",
                      },
                      TR_STYLE,
                    )}
                    ref={input => {
                      this.longNameInput = input;
                    }}
                  />
                </td>
                <td style={{ width: INIT_WIDTH }}>
                  <input
                    type="text"
                    value={shortName}
                    onChange={this.onChangeShortName}
                    placeholder="init."
                    style={Object.assign(
                      {
                        boxSizing: "border-box",
                        width: INIT_WIDTH,
                        backgroundColor: INPUT_GRAY,
                        border: "none",
                      },
                      TR_STYLE,
                    )}
                    size={3}
                  />
                </td>
                <td
                  style={{
                    backgroundColor: COLOR_GREEN,
                    color: "white",
                    textAlign: "center",
                  }}
                  onClick={this.onClickAddPlayer}
                >
                  add
                </td>
              </tr>
            )}
            {plusRow}
          </tbody>
        </table>
      </div>
    );
  }
}
PlayerList.propTypes = {
  players: PropTypes.instanceOf(OrderedMap).isRequired,
  picks: PropTypes.instanceOf(Picks),
  selected: PropTypes.instanceOf(Player),
  onClickPlayer: PropTypes.func.isRequired,
  addPlayer: PropTypes.func.isRequired,
  deselectPlayer: PropTypes.func.isRequired,
  lobbyCode: PropTypes.string.isRequired,
};

export default PlayerList;



// WEBPACK FOOTER //
// ./src/PlayerList.js